
<div class="fdm-floatbar" style="min-height:550px;">

  <div class="fdm-sidebar-header fdm-sidebar-header-primary fdm-buttons fdm-shadow clearfix">

    <li class="fdm-linked fdm-options-button pointer" (click)="cancel()">
      <fa-icon icon="times"></fa-icon>
    </li>
    <li class="fdm-linked fdm-options-button pointer" (click)="mapService.viewer.flyTo(jobAreaEntity)" [matTooltip]="'MAP.FLY_TO' | translate">
      <fa-icon icon="paper-plane"></fa-icon>
    </li>

    <li *ngIf="jobAreaEntity" class="fdm-linked fdm-options-button">
    <!--  <span class="fdm-checkboxes">
        <input id="showArea" type="checkbox" class="fdm-checkbox" [(ngModel)]="showCoverageArea" (change)="showHideCoverageArea()" />
        <label for="showArea">Area</label>
      </span>-->
    </li>

    <h2>{{ 'MAP.PHOTOGRAM.TITLE' | translate }}</h2>
  </div>

  <div  class="fdm-sidebar-body fdm-sidebar-content text-center" *ngIf="loading">
    <mat-spinner style="margin:2rem auto;" strokeWidth="3"></mat-spinner>
  </div>

  <div class="fdm-sidebar-body fdm-sidebar-content fdm-buttons" *ngIf="!hasImages">
    {{ 'MAP.PHOTOGRAM.UPLOAD_IMAGES' | translate }}
    <br>
    <div class="fdm-big-choice-box">
      <button class="fdm-button fdm-process-button active" (click)="cancel()">
        <fa-icon class="mr-1" icon="times"></fa-icon> {{ 'GENERIC.CLOSE' | translate }}
      </button>
    </div>
  </div>

  <div class="fdm-sidebar-body fdm-sidebar-content" *ngIf="currentJob && !loading && hasImages">

    <div class="mt-2 mb-2" *ngIf="jobRunning" style="border-radius:5px;background-color:#eee;padding:10px;">
      <!-- percent=[{{ progressPercent }}] stage=[{{ progressStage }}] timeleft=[{{ timeLeft }}] stage=[{{ progressStage }}] -->
      <span style="font-size: 70%;" *ngIf="!timeLeft">{{'MAP.PHOTOGRAM.PREPARING_DATA' | translate }}</span> <br>
      <span style="font-size: 70%;" >{{'MAP.PHOTOGRAM.PROCESSING_STAGE' | translate }} {{progressStage}} 
        <span *ngIf="progressPercent > 0"> ({{ progressPercent/100 | percent }}%) </span>
        <span *ngIf="progressPercent < 1"> (queued) </span>
      </span> <br>
      <mat-progress-bar [mode]="(progressPercent && progressPercent > 0) ? 'determinate' : 'indeterminate'" [value]="progressPercent"></mat-progress-bar>
    </div>

    <div class="fdm-background-accent clearfix mt-2 mb-2" *ngIf="currentJob && currentJob['lastJobStatus'] && currentJob['lastJobStatus'] !== 'ok'" style="color:#fff;border-radius:5px;padding:10px;">
      {{ 'MAP.PHOTOGRAM.FAILED_JOB' | translate }}
<pre style="font-size:9px;color:#fff;background-color:rgba(0,0,0,0.2)">
{{ currentJob['lastJobReport'] | json }}
</pre>
    </div>

  <!-- currentJob=[{{currentJob}}] jobRunning=[{{jobRunning}}] folderAdded=[{{folderAdded}}] disablePreviewRun=[{{disablePreviewRun}}] canStartFullProcess=[{{canStartFullProcess}}]
  selectionEnabled={{selectionEnabled}} pdfReport=[{{pdfReport}}] -->

    <!-- hasRunPreview=[{{ currentJob['hasRunPreview'] }}] hasRunFull=[{{ currentJob['hasRunFull'] }}] -->

    <div class="fdm-big-choice-box" *ngIf="!currentJob['hasRunPreview'] && !jobRunning">
      <label>{{ 'MAP.PHOTOGRAM.SETUP' | translate }}</label>

      <button (click)="importMetadata(false)" id="guide-open-photogrammetry-setup"
          class="fdm-button fdm-process-button active" 
          [disabled]="!currentJob || jobRunning">
        <fa-icon class="mr-1" icon="images"></fa-icon> <!-- {{'MAP.PHOTOGRAM.IMPORT_FOLDER_METADATA' | translate }} -->
        {{ 'MAP.PHOTOGRAM.CAMERA_SETUP' | translate }}
      </button>
      
      <!--
      <div class="fdm-checkboxes" *ngIf="currentJob">
        <input id="check-coords"  type="checkbox" class="fdm-checkbox" [(ngModel)]="showOptionalCoords"/>
        <label for="check-coords"></label> I have optional image coordinates
      </div>
      <div class="clearfix"></div>
-->
      
      <button id="guide-open-photogrammetry-preview" class="fdm-button fdm-process-button" 
        [class.active]="currentJob && !jobRunning && folderAdded && !importMetaDataError && !disablePreviewRun && currentJob['metaSaved']" 
        [disabled]="!currentJob || jobRunning || importMetaDataError || !folderAdded || disablePreviewRun || edgeBrowserError || !currentJob['metaSaved']" 
        (click)="runXForm(currentJob.jobType.baseTransform, false)">
        <fa-icon class="mr-1" icon="puzzle-piece"></fa-icon> <!-- {{'MAP.PHOTOGRAM.START_PRE-PROCESSING' | translate }} -->
        {{ 'MAP.PHOTOGRAM.CREATE_PREVIEW' | translate }}
      </button>
    </div>
    <div class="fdm-big-choice-box" *ngIf="currentJob['hasRunPreview'] && !jobRunning">
      <label>{{ 'MAP.PHOTOGRAM.SETUP' | translate }}</label>
      <p>{{ 'MAP.PHOTOGRAM.SETUP_COMPLETE' | translate }}</p>
      <p *ngIf="!currentJob['hasRunFull']">{{ 'GENERIC.NOTE' | translate }}: {{ 'MAP.PHOTOGRAM.PRODUCTS_PENDING' | translate }}</p>
    </div>

    <div class="fdm-big-choice-box" *ngIf="!currentJob['hasRunFull'] && !jobRunning">
      <label>{{ 'MAP.PHOTOGRAM.FINAL_PROCESSING' | translate }}</label>

<!-- The vertical reference used for height is the 'Arbitrary' system -->

      <button class="fdm-button fdm-process-button float-right" id="guide-open-photogrammetry-gcps"
        [class.active-light]="!jobRunning"
        [class.noshow]="!showOptionalControlPoints || !canStartFullProcess"
        [disabled]="!canStartFullProcess || jobRunning" 
        (click)="importMetadata(true)">
        <fa-icon class="mr-1" icon="dot-circle"></fa-icon> <!-- {{'MAP.PHOTOGRAM.IMPORT_REFERENCES' | translate }} -->
        {{ 'MAP.PHOTOGRAM.SETUP2' | translate }}
      </button>
      <div class="fdm-checkboxes">
        <input id="guide-check-photogrammetry-gcps"  type="checkbox" class="fdm-checkbox" [(ngModel)]="showOptionalControlPoints"/>
        <label for="guide-check-photogrammetry-gcps"></label> {{ 'MAP.PHOTOGRAM.CONTROL_POINTS' | translate }}
      </div>
      <div class="clearfix">
        <p class="alert primary-bg-light" style="padding:10px!important;margin-top:8px!important;font-size:0.9em;" *ngIf="showOptionalControlPoints && !canStartFullProcess">{{ 'MAP.PHOTOGRAM.INITIAL_SETUP' | translate }}</p>
      </div>

      <div *ngIf="referenceAnnotation.size > 0" style="text-align: center" [ngClass]="!currentJob?.amountPaid ? 'disabledbutton' : ''" class="mt-2 mb-2" [class.noshow]="!showOptionalControlPoints">


            <!-- <span class="ml-1 small-font-desc"> {{'MAP.PHOTOGRAM.IMPORTED_REFERENCES' | translate }}</span> -->
            <table class="table table-hover" border="1">
              <tbody>
              <tr style="padding: 0rem;">
                <td style="padding: 0rem; border-top: 0px solid;">
                  <span>{{'MAP.PHOTOGRAM.NAME' | translate }}</span>
                </td>
                <td style="padding: 0rem;border-top: 0px solid;">
                  <span>{{'MAP.PHOTOGRAM.FULL_CONTROL' | translate }}</span>
                </td>
                <td></td>
              </tr>
              <ng-container *ngFor="let item of referenceAnnotation | keyvalue;let i = index">
              <tr [ngStyle]="currentWorkingReferenceAnnotation == item.value ? {'backgroundColor': 'lightskyblue'} : ''" style="padding: 0rem;" 
              >
                <td style="padding: 0rem;">
                  <button style="color: rgba(0, 0, 0, 0.54);font-size: 12px;" type="button" [ngClass]="clickedButton === i ? 'a-button' : ''" 
                    class="btn btn-link fdm-linked"   mat-button (click)="clickedButton = i; flyToAnnotation(item.value)">
                      <fa-icon icon="paper-plane"></fa-icon> {{item.value.imageName}}
                  </button>
                </td>
                <td style="padding: 0rem; cursor: pointer;">
                  <mat-checkbox (change)="saveReference()"  [(ngModel)]="item.value.turnOn" >
                    <span class="ml-1 small-font-desc" *ngIf="item.value.referenceAnnotationMarkedImages">
                      <span>({{item.value.referenceAnnotationMarkedImages.length}} {{ 'MAP.PHOTOGRAM.PHOTOS' | translate }})</span>
                    </span>
                    <span class="ml-1 small-font-desc" *ngIf="!item.value.referenceAnnotationMarkedImages">
            ({{ 'MAP.PHOTOGRAM.ZERO_PHOTOS' | translate }})
            </span>
                  </mat-checkbox>

                  <!-- <div *ngIf="item.value.turnOn">
                    <li *ngFor="let img of item.value.referenceAnnotationMarkedImages; let idx = index">
                      {{ idx + 1 }}: {{ img.imageName }}
                    </li>
                  </div> -->
  
                  <!-- <textarea>{{ r | json }}</textarea> -->
                </td>

                <td style="padding: 3px;"><fa-icon icon="trash" style="color:red'" (click)="deleteGCP(item.value)"></fa-icon></td>
              </tr>
              </ng-container>
              </tbody>
            </table>
         
          
          <!-- <button class="mt-2 stroke-button" [disabled]="!canStartFullProcess || jobRunning || edgeBrowserError" (click)="runXForm(cur, true)" *ngFor="let cur of currentJob?.jobType?.subTransforms.items | async" mat-stroked-button >
            {{'MAP.PHOTOGRAM.START_FULL-PROCESSING' | translate }}
          </button> -->
  
        <!-- <a mat-icon-button [matTooltip]="'MAP.PHOTOGRAM.DOWNLOAD_REPORT' | translate " vlink="data" *ngIf="pdfRefport" [model]="pdfRefport"><fa-icon class="mr-1" icon="download"></fa-icon> {{'MAP.PHOTOGRAM.DOWNLOAD_REPORT' | translate }} </a> -->
      </div>

      <div class="fdm-checkboxes mb-2" *ngIf="currentJob && !jobRunning">
        <input id="check-selection"  type="checkbox" class="fdm-checkbox" [(ngModel)]="showOptionalSelection"/>
        <label for="check-selection"></label> {{ 'MAP.PHOTOGRAM.PROCESS_AREA' | translate }}
      </div>
      <div class="clearfix"></div>
      <div class="mt-2 mb-2" [class.noshow]="!showOptionalSelection">
        <button [matTooltip]="'MAP.PHOTOGRAM.SELECT_AREA' | translate" [disabled]="!canStartFullProcess || jobRunning || selectionEnabled" (click)="selectArea()" mat-mini-fab color="primary">
          <fa-icon icon="mouse-pointer"></fa-icon>

        </button>
        <span class="ml-2 stroke-span" >
          {{'MAP.PHOTOGRAM.SELECT_AREA' | translate }}
        </span>

        <button [matTooltip]="'MAP.PHOTOGRAM.CLEAR_AREA' | translate" [disabled]="!canStartFullProcess || jobRunning || (selector && !selector.show)" class="ml-2" (click)="clearArea()" mat-mini-fab color="primary">
          <fa-icon icon="eraser"></fa-icon>
        </button>
        <span class="ml-2 stroke-span" >
          {{'MAP.PHOTOGRAM.CLEAR_AREA' | translate }}
        </span>
        <div class="mb-2"></div>
      </div>


      <!-- <div style=" border:solid 1px green; padding:5px; margin:5px; " *ngFor="let cur of subTransforms">
        {{ cur.name}} [{{ cur.uid }}]
      </div> -->


      <button class="fdm-button fdm-process-button" id="guide-start-photogrammetry"
        [class.active]="canStartFullProcess && !jobRunning" 
        [disabled]="!canStartFullProcess || jobRunning || edgeBrowserError" 
        (click)="runXForm(cur, true)" *ngFor="let cur of subTransforms">
        <fa-icon class="mr-1" icon="pray"></fa-icon> <!-- {{'MAP.PHOTOGRAM.START_FULL-PROCESSING' | translate }} -->
        {{ 'MAP.PHOTOGRAM.START_PROCESS' | translate }}
      </button>

   </div>
    <div class="fdm-big-choice-box" *ngIf="currentJob['hasRunFull'] && !jobRunning">
      <label>{{ 'MAP.PHOTOGRAM.FINAL_PROCESSING' | translate }}</label>
      <p>{{ 'MAP.PHOTOGRAM.FINISH_PROCESS' | translate }}</p>
      <p>{{ 'MAP.PHOTOGRAM.ANOTHER_JOB' | translate }}</p>
      <p>{{ 'MAP.PHOTOGRAM.FINISH_TIME' | translate }}</p>
    </div>

    <div class="fdm-big-choice-box" *ngIf="pdfRefport">
      <label>{{ 'MAP.PHOTOGRAM.PROCESSING_REPORT' | translate }}</label>
      <a class="fdm-button fdm-process-button fdm-annotation-background-gray" vlink="data" [model]="pdfRefport">
        <fa-icon class="mr-1" icon="download"></fa-icon> {{ 'MAP.PHOTOGRAM.DOWNLOAD_REPORT' | translate }}
      </a>
    </div>

    <div class="mt-2" style="margin-top:30px;text-align:center;padding-top:40px;">
      <small (click)="debugJob = debugJob + 1">Powered by Agisoft </small> <img style="width: 100px;" src="/assets/images/Metashape_logo_.png">
    </div>

    <div *ngIf="debugJob > 3">
      <table class="fdm-debug-table">

        <tr class="banner"> <td colspan="2">{{ 'MAP.PHOTOGRAM.PROCESS' | translate }}</td></tr>
        <tr>  <td class="header">canStartFullProcess</td> <td>{{ canStartFullProcess }}</td> </tr>
        <tr>  <td class="header">canRestJobRunning</td> <td>{{ canRestJobRunning }}</td> </tr>
        <tr>  <td class="header">refreshStatusInterval</td> <td>{{ refreshStatusInterval }}</td> </tr>
        <tr>  <td class="header">canStartFullProcess</td> <td>{{ canStartFullProcess }}</td> </tr>
        <tr>  <td class="header">folderAdded</td> <td>{{ folderAdded }}</td> </tr>
        <tr>  <td class="header">referenceUploaded</td> <td>{{ referenceUploaded }}</td> </tr>
        <tr>  <td class="header">metaDataUploaded</td> <td>{{ metaDataUploaded }}</td> </tr>
        <tr>  <td class="header">selectionEnabled</td> <td>{{ selectionEnabled }}</td> </tr>
        <tr>  <td class="header">proceesingPay</td> <td>{{ proceesingPay }}</td> </tr>
        <tr>  <td class="header">gigaPixels</td> <td>{{ gigaPixels }}</td> </tr>
        
        <tr class="banner"> <td colspan="2">{{ 'MAP.PHOTOGRAM.PROGRESS' | translate }}</td></tr>
        <tr>  <td class="header">jobRunning</td> <td>{{ jobRunning }}</td> </tr>
        <tr>  <td class="header">batchUpdate</td> <td>{{ batchUpdate }}</td> </tr>
        <tr>  <td class="header">progressStage</td> <td>{{ progressStage }}</td> </tr>
        <tr>  <td class="header">progressPercent</td> <td>{{ progressPercent }}</td> </tr>
        <tr>  <td class="header">timeLeft</td> <td>{{ timeLeft }}</td> </tr>
        
        <tr class="banner"> <td colspan="2">{{ 'MAP.PHOTOGRAM.CURRENT_JOB' | translate }}</td></tr>
        <tr>  <td class="header">name, id</td> <td>{{ currentJob?.name }}, {{ currentJob?.id }}</td> </tr>
        <tr>  <td class="header">status</td> <td>{{ currentJob?.status }}</td> </tr>
        <tr>  <td class="header">dateMade</td> <td>{{ currentJob?.dateMade | dateAgo | async }}</td> </tr>
        <tr>  <td class="header">dateUpdated</td> <td>{{ currentJob?.dateUpdated | dateAgo | async }}</td> </tr>
        <tr>  <td class="header">current</td> <td>{{ currentJob?.current?.id }}</td> </tr>
        <tr>  <td class="header">jobType</td> <td>{{ currentJob?.jobType?.id }}, {{ currentJob?.current?.type }}</td> </tr>
        <tr>  <td class="header">jobType subs</td> <td>{{ currentJob?.jobType?.subTransforms }}</td> </tr>
        <tr>  <td class="header">jobType sub items</td> <td>{{ currentJob?.jobType?.subTransforms?.items.length }}</td> </tr>
        <tr>  <td class="header">isFullProcessing</td> <td>{{ currentJob?.isFullProcessing }}</td> </tr>
        <tr>  <td class="header">isFree</td> <td>{{ currentJob?.isFree }}</td> </tr>
        <tr>  <td class="header">amountPaid</td> <td>{{ currentJob?.amountPaid }}</td> </tr>
        <tr>  <td class="header">DATA_FROM_FOLDER</td> <td>{{ currentJob?.DATA_FROM_FOLDER }}</td> </tr>
        <tr>  <td class="header">doTile</td> <td>{{ currentJob?.doTile }}</td> </tr>
        <tr>  <td class="header">doLAZ</td> <td>{{ currentJob?.doLAZ }}</td> </tr>
        <tr>  <td class="header">doDEM</td> <td>{{ currentJob?.doDEM }}</td> </tr>
        <tr>  <td class="header">doTMS</td> <td>{{ currentJob?.doTMS }}</td> </tr>
        <tr>  <td class="header">JOB_EPSG_CODE</td> <td>{{ currentJob?.JOB_EPSG_CODE }}</td> </tr>

        <tr class="banner"> <td colspan="2">{{ 'MAP.PHOTOGRAM.CURRENT_JOB_COORDS' | translate }}</td></tr>
        
        <tr>  <td class="header">CsvCoordsDifferentCRS</td> <td>{{ currentJob?.CsvCoordsDifferentCRS }}</td> </tr>
        <tr>  <td class="header">CsvCoordsXYFlipped</td> <td>{{ currentJob?.CsvCoordsXYFlipped }}</td> </tr>
        <tr>  <td class="header">latLongSwap</td> <td>{{ currentJob?.latLongSwap }}</td> </tr>

        <tr class="banner"> <td colspan="2">{{ 'MAP.PHOTOGRAM.MISCELLANEOUS' | translate }}</td></tr>
        <tr>  <td class="header">metaIndex</td> <td><textarea style="width:100%;height:80px;font-size:8px;">{{ currentJob?.metaIndex | json }}</textarea></td> </tr>
        <tr>  <td class="header">group</td> <td><textarea style="width:100%;height:80px;font-size:8px;">{{ currentJob?.group | json }}</textarea></td> </tr>
        <tr>  <td class="header">canonical</td> <td><textarea style="width:100%;height:200px;font-size:8px;">{{ {camera: currentJob?.canonical_camera_coords, gcp: currentJob?.canonical_gcp_coords } | json }}</textarea></td> </tr>
        
        <tr class="banner"> <td colspan="2">{{ 'MAP.PHOTOGRAM.JOB_ATTACHMENTS' | translate }}</td></tr>
        <tr  *ngIf="currentJob['transforms'] && currentJob['transforms'].length">  <td colspan="2">
          <div class="header">{{ 'MAP.PHOTOGRAM.TRANSFORMS' | translate }} ({{ currentJob?.transforms?.length }})</div>
          <div *ngFor="let item of currentJob.transforms; let i = index;" style="padding:2px;border-bottom:solid 1px #eee;">
            {{ item.id }} ({{ item.type }}) "{{ item.status }}"
          </div>
        </td> </tr>
        <tr *ngIf="currentJob['datasets'] && currentJob['datasets'].length">  <td colspan="2">
          <div class="header">{{ 'MAP.PHOTOGRAM.DATASETS' | translate }} ({{ currentJob?.datasets?.length }}) </div>
          <div *ngFor="let item of currentJob.datasets; let i = index;" style="padding:2px;border-bottom:solid 1px #eee;">
             {{ item.name }} ({{ item.ds_id }}) [{{ item.ds_type }}]
  
          </div>
        </td> </tr>
        <tr>  <td class="header">pdfRefport</td> <td>{{ pdfRefport?.name }} [{{ pdfRefport?.id }}]</td> </tr>
        <tr>  <td class="header">COORD_FILE</td> <td>{{ currentJob?.COORD_FILE }} </td> </tr>
        <tr>  <td class="header">REFERENCE_FILE</td> <td>{{ currentJob?.CREFERENCE_FILE }} </td> </tr>
        
        <tr class="banner"> <td colspan="2">{{ 'MAP.PHOTOGRAM.GLOBALS' | translate }}</td></tr>
        <tr>  <td class="header">rectangle</td> <td><textarea style="width:100%;height:80px;font-size:8px;">{{ jobArea | json }}</textarea></td> </tr>
        <tr>  <td class="header">areaEntity</td> <td>{{ jobAreaEntity?.id }}</td> </tr>
        <tr>  <td class="header">currentScene name, id</td> <td>{{ currentScene?.name }}, {{ currentScene?.id }}</td> </tr>
        <tr>  <td class="header">initialTransform name, id</td> <td>{{ initialTransform?.name }}, {{ initialTransform?.id }}</td> </tr>
        <tr>  <td class="header">transformsFromFolder</td> <td><textarea style="width:100%;height:80px;font-size:8px;">{{ transformsFromFolder | json }}</textarea></td> </tr>
        <tr>  <td class="header">plottedTransform</td> <td><textarea style="width:100%;height:80px;font-size:8px;">{{ plottedTransform | json }}</textarea></td> </tr>
        <tr>  <td class="header">plottedTransformFull</td> <td><textarea style="width:100%;height:80px;font-size:8px;">{{ plottedTransformFull | json }}</textarea></td> </tr>
        <tr>  <td class="header">referenceAnnotation</td> <td><textarea style="width:100%;height:80px;font-size:8px;">{{ referenceAnnotation | json }}</textarea></td> </tr>
        <!-- <tr>  <td class="header">cameraPositionsFromFolder</td> <td><textarea style="width:100%;height:80px;font-size:8px;">{{ cameraPositionsFromFolder | json }}</textarea></td> </tr>
        <tr>  <td class="header">cameraPositionsFromFolderID</td> <td><textarea style="width:100%;height:80px;font-size:8px;">{{ cameraPositionsFromFolderID | json }}</textarea></td> </tr>
        -->
        <tr class="banner"> <td colspan="2">{{ 'MAP.PHOTOGRAM.JOB_RELATE' | translate }}</td></tr>
        <tr>  <td colspan="2"><textarea style="width:100%;height:280px;font-size:8px;">{{ everything | json }}</textarea></td> </tr>         
      </table>
    </div>

  <!-- <div class="mt-2 ml-2">

  <h6 *ngIf="group && group.name" style="color: #666;">
    {{ 'MAP.PHOTOGRAM.TITLE' | translate }}
  </h6>
  </div> -->
  
<!-- <div style="width:100%;font-size:8px;"><textarea style="width:100%;height:200px;">{{ currentJob | json }}</textarea></div>
<table>
  <tr *ngFor="let r of csvRecords; let i = index">
    <td style="width:100%;font-size:8px;"><textarea style="width:100%;">{{ r | json }}</textarea></td>
  </tr>
</table> -->

  </div>
</div>
